import { render, staticRenderFns } from "./CreateAgencyClientButton.vue?vue&type=template&id=61e0d9ee&"
import script from "./CreateAgencyClientButton.vue?vue&type=script&lang=js&"
export * from "./CreateAgencyClientButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports